// extracted by mini-css-extract-plugin
export default {"titlecontainer":"TitleSponsor_titlecontainer__s78m4","titlecard":"TitleSponsor_titlecard__HDcC4","sub":"TitleSponsor_sub__mQiO7"};